import React, { useEffect, useRef, useState } from 'react';

const Video = (props) => {
    const videoRef = useRef(null);
    const [isPosterVisible, setIsPosterVisible] = useState(true);
    const { video, poster, onPlaying, onLoadedData, ...attributes } = props;

    const handleVideoEnd = () => {
        const videoElement = videoRef.current;
        videoElement.pause();
        videoElement.currentTime = 0.44;
        videoElement.play();
    };

    const handlePlaying = (event) => {
        setIsPosterVisible(false);
        if (typeof onPlaying === 'function') {
            onPlaying(event);
        }
    };

    const handleLoadedData = (event) => {
        if (typeof onLoadedData === 'function') {
            onLoadedData(event);
        }
    };

    useEffect(() => {
        const videoElement = videoRef.current;
        videoElement.addEventListener('ended', handleVideoEnd);

        return () => {
            videoElement.removeEventListener('ended', handleVideoEnd);
        };
    }, []);

    return (
        <div style={{ position: 'relative' }}>
            {poster && (
                <img
                    src={poster}
                    alt=""
                    aria-hidden="true"
                    style={{
                        position: 'absolute',
                        inset: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        opacity: isPosterVisible ? 1 : 0,
                        transition: 'opacity 280ms ease',
                        pointerEvents: 'none',
                    }}
                />
            )}
            <video
                {...attributes}
                ref={videoRef}
                poster={poster}
                onPlaying={handlePlaying}
                onLoadedData={handleLoadedData}
                playsInline
                controls={false}
                controlsList="nofullscreen nodownload noplaybackrate noremoteplayback"
                disablePictureInPicture
                disableRemotePlayback
                webkit-playsinline="true"
                x5-playsinline="true"
                x5-video-player-type="h5"
                x5-video-player-fullscreen="false"
            >
                <source src={video} type="video/mp4" />
            </video>
        </div>
    );
};

export default Video;
